<template>
  <el-card shadow="never" class="aui-card--fill">
    <div>
      <h2 class="title">企业商家注册账号资料</h2>
      <el-form
        :model="dataForm2"
        ref="dataForm"
        label-width="220px"
        justify="center"
      >
        <h3>用户基本资料</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="username" label="登录账号：">
              <span>{{ dataForm2.username }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="mobile" label="手机号：">
              <span>{{ dataForm2.mobile }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="realName" label="姓名：">
              <span>{{ dataForm2.realName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="email" label="邮箱：">
              <span>{{ dataForm2.email }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>基础信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="姓名" prop="legalRealName">
              <span>{{ dataForm2.legalRealName }}</span>
              <!-- <el-input
                v-model="dataForm2.legalRealName"
                placeholder="请输入姓名"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="商家名称" prop="welfareMerchantName">
              <span>{{ dataForm2.welfareMerchantName }}</span>
          
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <el-form-item label="身份证号" prop="legalIdCardNumber">
              <span>{{ dataForm2.legalIdCardNumber }}</span>
              <!-- <el-input
                v-model="dataForm2.legalIdCardNumber"
                placeholder="请输入身份证号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手机号" prop="legalMobilePhone">
              <span>{{ dataForm2.legalMobilePhone }}</span>
              <!-- <el-input
                v-model="dataForm2.legalMobilePhone"
                placeholder="请输入手机号"
                autocomplete="off"
                maxlength="11"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="商家类型" prop="welfareMerchantType">
            <span>{{
              dataForm2.welfareMerchantType == 1 ? "个人" : "企业"
            }}</span>
            <!-- <el-select
              v-model="dataForm2.welfareMerchantType"
              placeholder="请选择"
              style="width: 440px"
              @change="selectChantType"
            >
              <el-option label="个人" :value="1"></el-option>
              <el-option label="企业" :value="2"></el-option>
            </el-select> -->
          </el-form-item>
        </el-row>

        <h3 v-if="dataForm2.welfareMerchantType == 2">商家信息</h3>
        <!-- <el-row v-if="dataForm2.welfareMerchantType==2">
          <el-col :span="10">
            <el-form-item label="企业名称" prop="enterpriseName">
              <span>{{ dataForm2&&dataForm2.enterpriseName?dataForm2.enterpriseName:'--' }}</span>
           
            </el-form-item>
       
          </el-col>
        
        </el-row> -->

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <!-- <el-col :span="10">
            <el-form-item label="法人手机号：" prop="legalMobilePhone">
              <span>{{dataForm2.legalMobilePhone}}</span>
            
            </el-form-item>
          </el-col> -->
          <el-col :span="10">
            <!-- <el-form-item label="商家名称：" prop="welfareMerchantName">
              <span>{{dataForm2.welfareMerchantName}}</span>
  
            </el-form-item> -->
          </el-col>
        </el-row>

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <span>{{
                dataForm2 && dataForm2.enterpriseName
                  ? dataForm2.enterpriseName
                  : "--"
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="企业性质：" prop="enterpriseNature">
              <span v-if="dataForm2 && dataForm2.enterpriseNature == 1"
                >私营</span
              >
              <span v-if="dataForm2 && dataForm2.enterpriseNature == 2"
                >国企</span
              >
              <span v-if="dataForm2 && dataForm2.enterpriseNature == 3"
                >个体工商</span
              >
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="企业电话：" prop="enterprisePhone">
              <span>{{
                dataForm2 && dataForm2.enterprisePhone
                  ? dataForm2.enterprisePhone
                  : "--"
              }}</span>
              <!-- <el-input v-model="dataForm2.enterprisePhone" autocomplete="off"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10" style="display: flex">
            <el-form-item label="企业省份：" prop="enterpriseRegionProvince">
              <span>{{
                enterpriseRegionProvince ? enterpriseRegionProvince : "--"
              }}</span>
            </el-form-item>
            <el-form-item
              label="市："
              prop="enterpriseRegionCity"
              label-width="40px"
            >
              <span>{{
                enterpriseRegionCity ? enterpriseRegionCity : "--"
              }}</span>
            </el-form-item>
            <el-form-item
              label="区："
              prop="enterpriseRegion"
              label-width="40px"
            >
              <span>{{ enterpriseRegion ? enterpriseRegion : "--" }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="详细地址：" prop="enterpriseAddress">
              <span>{{
                dataForm2 && dataForm2.enterpriseAddress
                  ? dataForm2.enterpriseAddress
                  : "--"
              }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="企业网址：" prop="enterpriseWebSite">
              <span>{{dataForm2.enterpriseWebSite}}</span>
           
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- 账户信息 -->
        <h3>账户信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否作为代收账户" prop="isCollectionAccount">
              <span>{{
                dataForm2.isCollectionAccount == 1 ? "是" : "否"
              }}</span>
              <!-- <el-select
                v-model="dataForm2.isCollectionAccount"
                placeholder="请选择"
                style="width: 434px"
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="14"
            >(注：如果该账户作为代收账户,则在是否作为代收账户中选择是)</el-col
          >
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <span>{{
                dataForm2 && dataForm2.accountName
                  ? dataForm2.accountName
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <span>{{
                dataForm2 && dataForm2.accountBankNumber
                  ? dataForm2.accountBankNumber
                  : "--"
              }}</span>
              <!-- <el-input
                v-model="dataForm2.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <span>{{ dataForm2.accountBankName }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="返点值" prop="rebate">
              <span>{{
                dataForm2 && dataForm2.rebate
               
               
              }}</span>
              <!-- <el-input
                v-model="dataForm2.rebate"
                autocomplete="off"
                placeholder="请输入0-1之间的小数，最多三位小数"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="付款账期(天)" prop="accountPeriod">
              <span>{{ dataForm2.accountPeriod }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.accountPeriod"
                placeholder="请输入付款账期"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="机构号" prop="companyNo">
              <span>{{
                dataForm2 && dataForm2.companyNo ? dataForm2.companyNo : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.companyNo"
                placeholder="请输入机构号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 后面新增 -->
        <el-row>
          <el-col :span="10">
            <el-form-item label="节点号" prop="nodeNo">
              <span>{{
                dataForm2 && dataForm2.nodeNo ? dataForm2.nodeNo : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.nodeNo"
                placeholder="请输入节点号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户银行行号" prop="openBankNumber">
              <span>{{
                dataForm2 && dataForm2.openBankNumber
                  ? dataForm2.openBankNumber
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.openBankNumber"
                placeholder="请输入开户银行行号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="费项" prop="bizId">
              <span>{{
                dataForm2 && dataForm2.bizId ? dataForm2.bizId : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.bizId"
                placeholder="请输入费项"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-form-item label="操作类型：">
            <span>实时收款</span>
          </el-form-item>
        </el-row>

        <h3 v-if="dataForm2.welfareMerchantType == 2">执照信息</h3>
        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="营业类型" prop="businessScope">
              <span>{{
                dataForm2 && dataForm2.businessScope
                  ? dataForm2.businessScope
                  : "--"
              }}</span>
              <!-- <el-input
                type="text"
                v-model="chantTypeForm.businessScope"
                placeholder="请输入营业类型"
                autocomplete="off"
                maxlength="40"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="社会统一信用代码"
              prop="businessRegistrationNo"
            >
              <span>{{
                dataForm2 && dataForm2.businessRegistrationNo
                  ? dataForm2.businessRegistrationNo
                  : "--"
              }}</span>
              <!-- <el-input
                type="text"
                v-model="chantTypeForm.businessRegistrationNo"
                placeholder="请输入社会统一信用代码"
                autocomplete="off"
                maxlength="18"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="成立日期" prop="establishmentDate">
              <span>{{
                dataForm2 && dataForm2.establishmentDate
                  ? dataForm2.establishmentDate
                  : "--"
              }}</span>
              <!-- <el-date-picker
                v-model="chantTypeForm.establishmentDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd hh:mm:ss"
                style="width: 435px"
              ></el-date-picker> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="雇员人数" prop="employeesNumber">
              <span>{{
                dataForm2 && dataForm2.employeesNumber
                  ? dataForm2.employeesNumber
                  : ""
              }}</span>
              <!-- <el-input
                v-model="chantTypeForm.employeesNumber"
                placeholder="请输入雇员人数"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <h3 v-if="dataForm2.welfareMerchantType == 2">证件信息</h3>
        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item
              label="法人身份证正面上传："
              prop="idCardPicFrontList"
            >
              <el-image :src="dataForm2.idCardPicFrontUrlList&&dataForm2.idCardPicFrontUrlList[0]" :preview-src-list="idCardsrcList">
                <div slot="error" class="image-slot">
                  <span>--</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="法人身份证反面上传：">
              <el-image :src="dataForm2.idCardPicBackUrlList&&dataForm2.idCardPicBackUrlList[0]" :preview-src-list="backsrcList">
                <div slot="error" class="image-slot">
                  <span>--</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="dataForm2.welfareMerchantType == 2">
          <el-col :span="10">
            <el-form-item label="营业执照上传：">
              <el-image :src="dataForm2.businessLicensePicUrlList&&dataForm2.businessLicensePicUrlList[0]"  :preview-src-list="businesssrcList">
                <div slot="error" class="image-slot">
                  <span>--</span>
                </div>
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <h3 v-if="dataForm2.isCollectionAccount == 1">清算账户信息</h3>
        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <span>{{
                dataForm2 && dataForm2.accountName
                  ? dataForm2.accountName
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="clearForm.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <span>{{
                dataForm2 && dataForm2.accountBankNumber
                  ? dataForm2.accountBankNumber
                  : "--"
              }}</span>

              <!-- <el-input
                v-model="clearForm.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <span>{{
                dataForm2 && dataForm2.accountBankName
                  ? dataForm2.accountBankName
                  : "--"
              }}</span>

              <!-- <el-input
                type="type"
                v-model="clearForm.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="返点值" prop="rebate">
              <span>{{
                dataForm2.merchantSettleAccount &&
                dataForm2.merchantSettleAccount.rebate
               
              }}</span>

              <!-- <el-input
                v-model="clearForm.rebate"
                autocomplete="off"
                placeholder="请输入0-1之间的小数，最多三位小数"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>

        <h3 v-if="dataForm2.isCollectionAccount == 1">付款信息</h3>
        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <el-col :span="10">
            <el-form-item label="开户人" prop="accountName">
              <span>{{
                dataForm2.paymentAccount && dataForm2.paymentAccount.accountName
                  ? dataForm2.paymentAccount.accountName
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.accountName"
                placeholder="请输入开户人"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户" prop="accountBankNumber">
              <span>{{
                dataForm2.paymentAccount &&
                dataForm2.paymentAccount.accountBankNumber
                  ? dataForm2.paymentAccount.accountBankNumber
                  : "--"
              }}</span>
              <!-- <el-input
                v-model="dataForm2.accountBankNumber"
                placeholder="请输入银行账户"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <el-col :span="10">
            <el-form-item label="开户行" prop="accountBankName">
              <span>{{
                dataForm2.paymentAccount &&
                dataForm2.paymentAccount.accountBankName
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.accountBankName"
                placeholder="请输入开户行"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="协议号：" prop="payAgreementNumber">
              <span>{{
                dataForm2.paymentAccount &&
                dataForm2.paymentAccount.payAgreementNumber
              }}</span>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="返点值" prop="rebate">
              <span>{{
                dataForm2.paymentAccount &&
                dataForm2.paymentAccount.rebate &&
                dataForm2.paymentAccount.rebate
                  ? dataForm2.rebate
                  : "--"
              }}</span>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <!-- <el-col :span="10">
            <el-form-item label="付款账期(天)" prop="accountPeriod">
              <span>{{ dataForm2.paymentAccount&&dataForm2.paymentAccount.accountPeriod }}</span>
          
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="10">
            <el-form-item label="机构号" prop="companyNo">
              <span>{{ dataForm2.paymentAccount&&dataForm2.paymentAccount.companyNo?dataForm2.paymentAccount.companyNo:'--' }}</span>
           
            </el-form-item>
          </el-col> -->
        </el-row>

        <!-- 后面新增 -->
        <el-row v-if="dataForm2.isCollectionAccount == 1">
          <el-col :span="10">
            <el-form-item label="节点号" prop="nodeNo">
              <span>{{
                dataForm2.paymentAccount && dataForm2.paymentAccount.nodeNo
                  ? dataForm2.paymentAccount.nodeNo
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.nodeNo"
                placeholder="请输入节点号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户银行行号" prop="openBankNumber">
              <span>{{
                dataForm2.paymentAccount &&
                dataForm2.paymentAccount.openBankNumber
                  ? dataForm2.paymentAccount.openBankNumber
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.openBankNumber"
                placeholder="请输入开户银行行号"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dataForm2.isCollectionAccount == 1">
        
          <el-col :span="10">
            <el-form-item label="费项" prop="bizId">
              <span>{{
                dataForm2.paymentAccount && dataForm2.paymentAccount.bizId
                  ? dataForm2.paymentAccount.bizId
                  : "--"
              }}</span>
              <!-- <el-input
                type="type"
                v-model="dataForm2.bizId"
                placeholder="请输入费项"
                autocomplete="off"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
               <el-form-item label="操作类型：" prop="operateType">
            <span>实时付款</span>
          </el-form-item>
      
          </el-col>
         
       
        </el-row>
     

        <!-- 
        <el-row>
          <el-col :span="10">
            <el-form-item label="成立日期：" prop="establishmentDate">
              <span>{{ dataForm2.establishmentDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="雇员人数：" prop="employeesNumber">
              <span>{{ dataForm2.employeesNumber }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item
              label="法人身份证正面上传："
              prop="idCardPicFrontList"
            >
              <el-image :src="dataForm2.idCardPicFrontUrlList[0]"></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="法人身份证反面上传：" prop="idCardPicBackList">
              <el-image :src="dataForm2.idCardPicBackUrlList[0]"></el-image>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="营业执照上传：" prop="businessLicensePicList">
              <el-image
                :src="dataForm2.businessLicensePicUrlList[0]"
              ></el-image>
            </el-form-item>
          </el-col>
        </el-row> -->

        <!-- 账户信息 -->
        <!-- <el-row>
          <el-col :span="10">
            <el-form-item label="开户人：" prop="accountName">
              <span>{{ dataForm2.accountName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="银行账户：" prop="accountBankNumber">
              <span>{{ dataForm2.accountBankNumber }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="开户行：" prop="accountBankName">
              <span>{{ dataForm2.accountBankName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="返点值：" prop="rebate">
              <span>{{ dataForm2.rebate }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="付款账期：" prop="accountPeriod">
              <span>{{ dataForm2.accountPeriod }}</span>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="机构号：" prop="companyNo">
              <span>{{ dataForm2.companyNo }}</span>
            </el-form-item>
          </el-col>
        </el-row>

    
        <el-row>
          <el-col :span="10">
            <el-form-item label="节点号：" prop="nodeNo">
              <span>{{ dataForm2.nodeNo }}</span>
           
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="开户银行行号：" prop="openBankNumber">
              <span>{{ dataForm2.openBankNumber }}</span>
            
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="费项：" prop="bizId">
              <span>{{ dataForm2.bizId }}</span>
           
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="操作类型：">
              <span>实时收款</span>
            
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div style="text-align: center">
        <el-button
          @click="
            $router.push({
              name: 'enterpriseBusinessRegister',
              query: { record: 2 },
            })
          "
          >返回</el-button
        >
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      enterpriseRegionProvince: "",
      enterpriseRegionCity: "",
      enterpriseRegion: "",
       idCardsrcList: [
        
        ],
         backsrcList: [
        
        ],
         businesssrcList: [
        
        ],
      infoList: {},
      roleList2: [],
      roleList: [],
      dialogVisible: false,
      visible: false,
      type: null,
      dataForm2: {
        businessLicensePicUrlList: [],
        idCardPicBackUrlList: [],
        idCardPicFrontUrlList: [],
      },
      curForm: {
        id: "",
        tanantState: "1",
        tanantRemark: "",
        roleIdList: [],
      },
      src:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      radio: 1,
    };
  },
  created() {
    this.getRegistInfo(this.$route.query.id);
  },
  methods: {
    // 获取省份
    province() {
      // eslint-disable-line no-unused-vars
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 1,
          pid: 0,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.enterpriseRegionProvince = res.data.filter(
            (item) => item.id == this.dataForm2.enterpriseRegionProvince
          )[0].name;

          this.city();
        });
    },
    // 获取城市
    city() {
      this.pid = this.dataForm2.enterpriseRegionProvince;
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 2,
          pid: this.dataForm2.enterpriseRegionProvince,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.enterpriseRegionCity = res.data.filter(
            (item) => item.id == this.dataForm2.enterpriseRegionCity
          )[0].name;
          this.district();
        });
    },
    // 获取县
    district() {
      this.pid = this.dataForm2.enterpriseRegionCity;
      this.$request
        .post("/approver-api/api/wemp/region/list", {
          treeLevel: 3,
          pid: this.dataForm2.enterpriseRegionCity,
        })
        .then((res) => {
          console.log(res);
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }

          this.enterpriseRegion = res.data.filter(
            (item) => item.id == this.dataForm2.enterpriseRegion
          )[0].name;
        });
    },
    //获取银行全部信息
    async getRegistInfo(id) {
      const res1 = await this.$request.post(
        "/approver-api/api/wemp/approveEnterpriseCollectionAccount/info",
        { enterpriseAccountId: id }
      );
      const res2 = await this.$request.post(
        "/approver-api/api/wemp/approvetenantinformation/info",
        { tenantInformationId: res1.data.tenantInformationId }
      );
      //   this.infoList={...res1.data,...res2.data}
      this.dataForm2 = { ...res1.data, ...res2.data };
      // this.dataForm2={...res1.data}
               this.idCardsrcList= this.dataForm2.idCardPicFrontUrlList.length>0?this.dataForm2.idCardPicFrontUrlList:[]
         this.backsrcList=this.dataForm2.idCardPicBackUrlList.length>0?this.dataForm2.idCardPicBackUrlList:[]
         this.businesssrcList=this.dataForm2.businessLicensePicUrlList.length>0?this.dataForm2.businessLicensePicUrlList:[]
      console.log(this.infoList);

      this.province();
    },
  },
};
</script>

<style lang="less" scoped>
h3 {
  padding-left: 30px;
}

.el-image {
  height: 50px;
  width: 80px;
  img {
    width: 100%;
  }
}

.role {
  border: 1px solid #ccc;
  text-align: center;
  border-radius: 5px;
  float: left;
  margin-left: 2px;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
}
</style>
